import {
  Button,
  Inline,
  Modal,
  type ModalProps,
  Notification,
  Stack,
} from '@omnipresentgroup/design-system';
import { ContractorInvoiceBankTransferDetails } from '@omnipresentgroup/features';

export const MODAL_TITLE = 'Haven’t made your bank transfer yet?';
export const MODAL_DESCRIPTION =
  'Please use the below details for your manual bank transfer';
export const NOFITICATION_TITLE =
  'This invoice was part of a transaction to pay multiple invoices';

type Props = {
  modalProps: Omit<ModalProps, 'children'>;
  handleDone: (event: React.SyntheticEvent) => void;
  loading?: boolean;
  invoiceId: string;
  isBulkPayment?: boolean;
};

export const NotExpiredPaymentModal = ({
  modalProps,
  handleDone,
  loading,
  invoiceId,
  isBulkPayment,
}: Props) => {
  return (
    <Modal {...modalProps} span={6}>
      <Modal.Header title={MODAL_TITLE} description={MODAL_DESCRIPTION} />

      <Modal.Body>
        <Stack gap="24">
          {isBulkPayment && (
            <Notification
              id={'transaction-notification'}
              title={NOFITICATION_TITLE}
            />
          )}
          <ContractorInvoiceBankTransferDetails invoiceId={invoiceId} />
        </Stack>
      </Modal.Body>

      <Modal.Footer>
        <Inline justify="end" w="stretch">
          <Button variant="primary" onClick={handleDone} loading={loading}>
            Done
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
